import React from 'react'
import { useEffect } from "react"
import Header from 'Placements/Components/Login/Header/Header'
import Footer from 'Placements/Components/Login/Footer/Footer'
import Loader from "Placements/Components/Loader"

const Waiting = ({ props }: any) => {


    const check = (interval: NodeJS.Timeout) => {
        if (localStorage.getItem("dataPl") != null
            && localStorage.getItem("AuthorizationPl") != null) {
            clearInterval(interval);

            const data = JSON.parse(localStorage.getItem("dataPl"));

            if(data.usuario.Id_perfil === 2){
                window.location.href = '#/welcome';
            } else {
                window.location.href = "#/admin/test-list";
            }

        }
    }

    useEffect(() => {

        check(null)

        let count = 0

        const interval = setInterval(() => {
            check(interval)
            count += 1
            if (count > 10) {
                clearInterval(interval);
                window.location.href = '#/login'
            }
        }, 500);
    }, [])

    return (
        <div className="home-page">
            <Header />
            <div className="form-welcome">
                <Loader />
            </div >
            <Footer />
        </div>
    )
}

export default Waiting
